import restful from '../vuex'

const state = {
  ...restful.states('charge_coupon')
}

const getters = {
  ...restful.getters('charge_coupon')
}

const actions = {
  ...restful.actions('charge_coupons')
}

const mutations = {
  ...restful.mutations('charge_coupon')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
